import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import {
  GstIn_add,
  GstIn_Update,
  GstIn_Delete,
  fetchGstInSetup
} from "../../Redux/Einvoice&EwayBillSlice/Einvoice&EwayBill";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import Loader from "../../Components/Loader/Loader";

const GstIn_Setup = () => {
  const dispatch = useDispatch();

  const {
    GstInData,
    GstInLoading
  } = useSelector((state) => state.EinvoiceEwayBill);

  const { AllClients } = useSelector((state) => state.Client);

  const [formData, setFormData] = useState({
    ClientID: "",
    GstNo: "",
    UserName: "",
    Password: "",
  });

  useEffect(() => {
    dispatch(fetchAllClients());
    dispatch(fetchGstInSetup());
  }, [dispatch]);

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (formData) => {
    const errors = {};

    if (!formData.ClientID || formData.ClientID.trim() === "") {
      errors.ClientID = "Client is required";
    }
    if (!formData.GstNo || formData.GstNo.trim() === "") {
      errors.GstNo = "GST No is required";
    }
    if (!formData.UserName || formData.UserName.trim() === "") {
      errors.UserName = "User Name is required";
    }
    if (!formData.Password || formData.Password.trim() === "") {
      errors.Password = "Password is required";
    }

    return errors;
  };

  const handleEdit = (row) => {
    setEditId(row.GstInId);
    setFormData({
      ClientID: row.ClientID,
      GstNo: row.GstNo,
      UserName: row.UserName,
      Password: row.Password,
    });
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this GSTIN setup?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(GstIn_Delete({ id: row.GstInId })).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
      });
      dispatch(fetchGstInSetup());
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (editId) {
          await dispatch(GstIn_Update({ id: editId, formData })).unwrap();
          toast.success("GSTIN updated successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        } else {
          await dispatch(GstIn_add(formData)).unwrap();
          toast.success("GSTIN added successfully!!", {
            position: "top-right",
            autoClose: 1000,
          });
        }

        // Reset form
        setFormData({
          ClientID: "",
          GstNo: "",
          UserName: "",
          Password: "",
        });
        setEditId(null);
        setErrors({});
        dispatch(fetchGstInSetup());
      } catch (error) {
        toast.error(
          `Failed to ${editId ? "update" : "add"} Data: ${error.message || "Unknown error"}`,
          {
            position: "top-right",
            autoClose: 1000,
          }
        );
      }
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 0.5 },
    { field: "ClientName", headerName: "Client", flex: 1 },
    { field: "GstNo", headerName: "GST No", flex: 1 },
    { field: "UserName", headerName: "User Name", flex: 1 },
    { field: "Password", headerName: "Password", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows = Array?.isArray(GstInData) ? GstInData?.map((el, index) => ({
    id: index + 1,
    GstInId: el._id,
    ClientID: el?.ClientID?._id || el?.ClientID,
    ClientName: el?.clientname || el?.ClientID?.FullName || el?.ClientID?.WhaClientName || "--",
    GstNo: el?.GstNo,
    UserName: el?.UserName,
    Password: el?.Password,
  })) : [];

  if (GstInLoading && !GstInData?.length) {
    return <Loader />;
  }

  return (
    <div className="">
      <div className="title">
        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
          {editId ? "Update GSTIN Setup" : "Add GSTIN Setup"}
        </h3>
      </div>

      <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
        >
          {/* Client Dropdown */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">Client</h5>
            <select
              name="ClientID"
              value={formData.ClientID}
              onChange={handleChange}
              className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
            >
              <option value="">Select Client</option>
              {[...(AllClients?.data || [])]
                .sort((a, b) => (a.WhaClientName || a.FullName || "").localeCompare(b.WhaClientName || b.FullName || ""))
                .map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.FullName || client.name || client.CompanyName || client.WhaClientName} {client.MobileNo ? `- ${client.MobileNo}` : ''}
                  </option>
                ))}
            </select>
            {errors.ClientID && (
              <p className="text-red-500 text-sm mt-1">{errors.ClientID}</p>
            )}
          </div>

          {/* GST No Input */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">GST No</h5>
            <input
              type="text"
              name="GstNo"
              value={formData.GstNo}
              onChange={handleChange}
              className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
            />
            {errors.GstNo && (
              <p className="text-red-500 text-sm mt-1">{errors.GstNo}</p>
            )}
          </div>

          {/* User Name Input */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">User Name</h5>
            <input
              type="text"
              name="UserName"
              value={formData.UserName}
              onChange={handleChange}
              className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
            />
            {errors.UserName && (
              <p className="text-red-500 text-sm mt-1">{errors.UserName}</p>
            )}
          </div>

          {/* Password Input */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">Password</h5>
            <input
              type="text"
              name="Password"
              value={formData.Password}
              onChange={handleChange}
              className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
            />
            {errors.Password && (
              <p className="text-red-500 text-sm mt-1">{errors.Password}</p>
            )}
          </div>

          {/* Submit Button */}
          <div className="submit_Form col-span-12 flex justify-center mt-3">
            <button type="submit" className="All_button">
              {editId ? "Update" : "Submit"}
            </button>

            {editId && (
              <button
                type="button"
                className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                onClick={() => {
                  setFormData({
                    ClientID: "",
                    GstNo: "",
                    UserName: "",
                    Password: "",
                  });
                  setEditId(null);
                  setErrors({});
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="px-2 py-6">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block text-uppercase rounded">
            View GSTIN Setup
          </h3>
        </div>
        <div className="rounded-lg overflow-x-auto mt-3">
          <WpDynamicTable columns={columns} rows={rows} height="450px" />
        </div>
      </div>
    </div>
  );
};

export default GstIn_Setup;